import React, { memo, ReactElement } from "react";

export interface CustomCloseIconProps {
    className?: string;
    size?: number;
    onClick?: VoidFunction;
    IconBgColor?: string;
    IconFillColor?: string;
    dataTestId?: string;
}

const DEFAULT_ICON_SIZE = 14;
const DEFAULT_ICON_BG_COLOR = "#E46D47";
const DEFAULT_ICON_FILL_COLOR = "#FFF1E7";

function CustomCloseIcon(props: CustomCloseIconProps): ReactElement {
    const {
        size = DEFAULT_ICON_SIZE,
        className,
        onClick,
        IconBgColor = DEFAULT_ICON_BG_COLOR,
        IconFillColor = DEFAULT_ICON_FILL_COLOR,
        dataTestId,
    } = props;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            className={className}
            data-testid={dataTestId} // Add this
        >
            <circle cx="14" cy="14" r="13.5" fill={IconBgColor} />
            <path
                d="M9.75729 9.75736L13.9999 14M18.2426 18.2426L13.9999 14M13.9999 14L18.2426 9.75736M13.9999 14L9.75729 18.2426"
                stroke={IconFillColor}
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default memo(CustomCloseIcon);
